// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__2p0q3"};